/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1SerievideoVideoidLangsIdMutationRequest,
  PutApiV1SerievideoVideoidLangsIdMutationResponse,
  PutApiV1SerievideoVideoidLangsIdPathParams,
  PutApiV1SerievideoVideoidLangsIdQueryParams,
  PutApiV1SerievideoVideoidLangsId400,
  PutApiV1SerievideoVideoidLangsId401,
  PutApiV1SerievideoVideoidLangsId404,
  PutApiV1SerievideoVideoidLangsId500,
} from "../../types/serieVideoIdiomasController/PutApiV1SerievideoVideoidLangsId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1SerievideoVideoidLangsId } from "../../clients/serieVideoIdiomasController/putApiV1SerievideoVideoidLangsId.ts";

export const putApiV1SerievideoVideoidLangsIdMutationKey = () =>
  [{ url: "/api/v1/serievideo/:videoId/langs/:id" }] as const;

export type PutApiV1SerievideoVideoidLangsIdMutationKey = ReturnType<
  typeof putApiV1SerievideoVideoidLangsIdMutationKey
>;

export function putApiV1SerievideoVideoidLangsIdMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PutApiV1SerievideoVideoidLangsIdMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = putApiV1SerievideoVideoidLangsIdMutationKey();
  return mutationOptions<
    PutApiV1SerievideoVideoidLangsIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1SerievideoVideoidLangsId400
      | PutApiV1SerievideoVideoidLangsId401
      | PutApiV1SerievideoVideoidLangsId404
      | PutApiV1SerievideoVideoidLangsId500
    >,
    {
      videoId: PutApiV1SerievideoVideoidLangsIdPathParams["videoId"];
      id: PutApiV1SerievideoVideoidLangsIdPathParams["id"];
      data?: PutApiV1SerievideoVideoidLangsIdMutationRequest;
      params?: PutApiV1SerievideoVideoidLangsIdQueryParams;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ videoId, id, data, params }) => {
      return putApiV1SerievideoVideoidLangsId(
        videoId,
        id,
        data,
        params,
        config,
      );
    },
  });
}

/**
 * @description Atualiza os textos de uma tradução (idioma) do vídeo. **(Requer Authorization para autenticação)**
 * @summary Atualizar idioma do vídeo (Requer Authorization para autenticação)
 * {@link /api/v1/serievideo/:videoId/langs/:id}
 */
export function usePutApiV1SerievideoVideoidLangsId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1SerievideoVideoidLangsIdMutationResponse,
      ResponseErrorConfig<
        | PutApiV1SerievideoVideoidLangsId400
        | PutApiV1SerievideoVideoidLangsId401
        | PutApiV1SerievideoVideoidLangsId404
        | PutApiV1SerievideoVideoidLangsId500
      >,
      {
        videoId: PutApiV1SerievideoVideoidLangsIdPathParams["videoId"];
        id: PutApiV1SerievideoVideoidLangsIdPathParams["id"];
        data?: PutApiV1SerievideoVideoidLangsIdMutationRequest;
        params?: PutApiV1SerievideoVideoidLangsIdQueryParams;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiV1SerievideoVideoidLangsIdMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    putApiV1SerievideoVideoidLangsIdMutationKey();

  const baseOptions = putApiV1SerievideoVideoidLangsIdMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1SerievideoVideoidLangsIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1SerievideoVideoidLangsId400
      | PutApiV1SerievideoVideoidLangsId401
      | PutApiV1SerievideoVideoidLangsId404
      | PutApiV1SerievideoVideoidLangsId500
    >,
    {
      videoId: PutApiV1SerievideoVideoidLangsIdPathParams["videoId"];
      id: PutApiV1SerievideoVideoidLangsIdPathParams["id"];
      data?: PutApiV1SerievideoVideoidLangsIdMutationRequest;
      params?: PutApiV1SerievideoVideoidLangsIdQueryParams;
    },
    TContext
  >;

  return useMutation<
    PutApiV1SerievideoVideoidLangsIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1SerievideoVideoidLangsId400
      | PutApiV1SerievideoVideoidLangsId401
      | PutApiV1SerievideoVideoidLangsId404
      | PutApiV1SerievideoVideoidLangsId500
    >,
    {
      videoId: PutApiV1SerievideoVideoidLangsIdPathParams["videoId"];
      id: PutApiV1SerievideoVideoidLangsIdPathParams["id"];
      data?: PutApiV1SerievideoVideoidLangsIdMutationRequest;
      params?: PutApiV1SerievideoVideoidLangsIdQueryParams;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1SerievideoVideoidLangsIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1SerievideoVideoidLangsId400
      | PutApiV1SerievideoVideoidLangsId401
      | PutApiV1SerievideoVideoidLangsId404
      | PutApiV1SerievideoVideoidLangsId500
    >,
    {
      videoId: PutApiV1SerievideoVideoidLangsIdPathParams["videoId"];
      id: PutApiV1SerievideoVideoidLangsIdPathParams["id"];
      data?: PutApiV1SerievideoVideoidLangsIdMutationRequest;
      params?: PutApiV1SerievideoVideoidLangsIdQueryParams;
    },
    TContext
  >;
}
